<template>
    <div>
        <div class="col-lg-12">
            <form class="needs-validation" autocomplete="off">
                <div class="form-group row">
                    <label class="col-sm-3 text-nowrap" style="min-width: 150px">{{ $t('managerForm.temporarily.nameTemp') }}</label>
                    <div class="col-sm-9">
                        {{ dataForm.template?.name }}
                    </div>
                </div>
                <div class="form-group row">
                    <label class="col-sm-3 text-nowrap" style="min-width: 150px">{{ $t('managerForm.settingBasic.nameCampaign') }}</label>
                    <div class="col-sm-9">
                        {{ dataForm.campaign?.name }}
                    </div>
                </div>
                <div class="form-group row">
                    <label class="col-sm-3 text-nowrap" style="min-width: 150px">クライアント </label>
                    <div class="col-sm-9">
                        {{ dataForm?.client?.name }}
                    </div>
                </div>

                <!-- フォーム名 -->
                <div class="form-group row">
                    <label class="col-sm-3 text-nowrap" style="min-width: 150px">{{ $t('managerForm.settingBasic.nameForm') }}</label>
                    <div class="col-sm-9">
                        {{ dataForm.name }}
                    </div>
                </div>

                <!-- chọn kiểu -->
                <div class="form-group row">
                    <label class="col-sm-3 text-nowrap" style="min-width: 150px">{{ $t('managerForm.settingPage.pageType') }} </label>
                    <div class="col-sm-9">{{ dataForm?.page_type?.label }}</div>
                </div>

                <!-- 公開パス -->
                <div class="form-group row">
                    <label class="col-sm-3 text-nowrap" style="min-width: 150px">{{ $t('managerForm.settingBasic.publicPath') }}</label>
                    <div class="col-sm-9">
                        <span v-if="![STATUS_FORM_LIST.PUBLISHING].includes(dataForm.status) || dataForm.is_first_create">{{ linkPublish }}</span>
                        <a v-else :href="linkPublish" target="_blank">{{ linkPublish }}</a>
                    </div>
                </div>

                <!-- TAG -->
                <div class="form-group row">
                    <label class="col-sm-3 text-nowrap" style="min-width: 150px">{{ $t('managerForm.settingBasic.tag') }}</label>
                    <div class="col-sm-9">
                        {{ dataForm?.hashtag?.join('、') }}
                    </div>
                </div>
                <template v-if="![ID_PAGE_TYPE.C].includes(dataForm.page_type?.id)">
                    <hr />
                    <div class="row pt-3">
                        <label class="col-sm-3 text-nowrap" style="min-width: 150px">
                            <h5 class="mb-4">オプション</h5>
                        </label>
                    </div>
                    <!-- URLパラメータ -->
                    <div class="form-group row">
                        <label class="col-sm-3 text-nowrap" style="min-width: 150px">{{ $t('managerForm.settingBasic.urlParam') }}</label>
                        <div class="col-sm-9" v-html="handleJoinParameter(dataForm.url_parameters)"></div>
                    </div>
                    <!-- 指定応募数 -->
                    <div class="form-group row">
                        <label class="col-sm-3 text-nowrap" style="min-width: 150px"
                            >{{ $t('managerForm.settingBasic.limitPersonApplication') }}
                        </label>
                        <div class="col-sm-9">
                            <!-- 制限件数 -->
                            <div class="form-group row">
                                <label class="col-sm-3 text-nowrap" style="min-width: 150px">{{ $t('managerForm.settingBasic.limitNumber') }} </label>
                                <div class="col-sm-9">
                                    <div class="d-flex">
                                        {{ dataForm.application_limit }}
                                        <span class="ml-2">件</span>
                                    </div>
                                </div>
                            </div>
                            <!-- 超過時リダイレクトURL -->
                            <div class="form-group row">
                                <label class="col-sm-3 text-nowrap" style="min-width: 180px">{{ $t('managerForm.settingBasic.redirectURL') }} </label>
                                <div class="col-sm-9">
                                    <a v-if="dataForm.url_redirect_when_limit" :href="dataForm.url_redirect_when_limit" target="_blank">{{
                                        dataForm.url_redirect_when_limit
                                    }}</a>
                                </div>
                            </div>
                            <!-- 期間前 -->
                            <div class="form-group row">
                                <label class="col-sm-3 text-nowrap" style="min-width: 180px"
                                    >{{ $t('managerForm.settingBasic.beforeThePeriod') }}
                                </label>
                                <div class="col-sm-9">
                                    <a v-if="dataForm.before_the_period_url" :href="dataForm.before_the_period_url" target="_blank">{{
                                        dataForm.before_the_period_url
                                    }}</a>
                                </div>
                            </div>
                            <!-- 期間後 -->
                            <div class="form-group row">
                                <label class="col-sm-3 text-nowrap" style="min-width: 180px"
                                    >{{ $t('managerForm.settingBasic.afterThePeriod') }}
                                </label>
                                <div class="col-sm-9">
                                    <a v-if="dataForm.after_the_period_url" :href="dataForm.after_the_period_url" target="_blank">{{
                                        dataForm.after_the_period_url
                                    }}</a>
                                </div>
                            </div>
                        </div>
                    </div>
                </template>
                <template v-if="dataForm.page_type?.id === ID_PAGE_TYPE.I">
                    <!-- 空メール有効期限 -->
                    <div class="form-group row">
                        <label class="col-sm-3 text-nowrap" style="min-width: 180px"
                            >{{ $t('managerForm.settingBasic.blankEmailExpirationDate') }}
                        </label>
                        <div class="col-sm-9">
                            <div class="form-group row">
                                <!-- 送信後 -->
                                <label class="col-sm-1 text-nowrap" style="min-width: 100px"
                                    >{{ $t('managerForm.settingBasic.afterSending') }}
                                </label>
                                <div class="col-sm-9">
                                    <template v-if="dataForm.link_expiration_time">
                                        <span class="mr-1">
                                            {{ dataForm.link_expiration_time }}
                                        </span>
                                        <span>{{ $t('text.minutes') }}</span>
                                    </template>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!-- 重複登録 -->
                    <div class="form-group row mb-4">
                        <label class="col-sm-3 text-nowrap" style="min-width: 180px"
                            >{{ $t('managerForm.settingBasic.duplicateRegistration') }}
                        </label>
                        <div class="col-sm-9">
                            <InputCheckBox
                                :model.sync="dataForm.allow_duplicate_email"
                                :id="`check-Allow_duplicate_email`"
                                :value="dataForm.allow_duplicate_email"
                                :label="$t('managerForm.settingBasic.noteDuplicateRegistration')"
                                :disabled="true"
                            />
                        </div>
                    </div>
                    <!-- 登録済みURLのエラー画面 -->
                    <div class="form-group row">
                        <label class="col-sm-3 text-nowrap" style="min-width: 180px"
                            >{{ $t('managerForm.settingBasic.settingNotRegisterAgain') }}
                        </label>
                        <div class="col-sm-9" style="white-space: pre-line" v-html="dataForm.setting_not_register_again"></div>
                    </div>
                </template>
                <template v-if="dataForm.page_type?.id === ID_PAGE_TYPE.B">
                    <SettingSerialCodeLottery
                        :dataForm="dataForm.setting_lottery"
                        :dataPrizes="dataForm.serial_code_prizes"
                        :dataSerialCode="dataForm.setting_serial_code"
                        :configValid="configValidFormLottery"
                        :isView="true"
                    />
                </template>
            </form>
        </div>
    </div>
</template>

<script>
import SettingSerialCodeLottery from '@/views/pages/phase2/manager-form/components/setting-lottery/main.vue';

import {
    TEMPORARILY,
    SOCIAL_MEDIA_LOGIN,
    STATUS_FORM,
    OPTION_PUBLIC_START_FORM,
    OPTION_PUBLIC_END_FORM,
    STATUS_FORM_LIST,
    ID_PAGE_TYPE
} from '../../../constants';
import { handleStatus } from '../../../handlers';
import { formatDateCommon } from '@/utils/format';
import { InputCheckBox } from '@/components/Input';
import { configFormLottery } from '@/views/pages/phase2/manager-form/components/setting-lottery/constants';

export default {
    name: 'SettingBasic',
    components: { InputCheckBox, SettingSerialCodeLottery },
    props: {
        dataForm: {
            type: Object,
            required: true,
            default: () => null
        }
    },
    data() {
        return {
            TEMPORARILY: TEMPORARILY,
            STATUS_FORM: STATUS_FORM,
            OPTION_PUBLIC_START_FORM: OPTION_PUBLIC_START_FORM,
            OPTION_PUBLIC_END_FORM: OPTION_PUBLIC_END_FORM,
            SOCIAL_MEDIA_LOGIN: this.dataForm?.setting_login_social?.length > 0 ? this.dataForm.setting_login_social : SOCIAL_MEDIA_LOGIN,
            STATUS_FORM_LIST,
            ID_PAGE_TYPE,
            configValidFormLottery: configFormLottery()
        };
    },
    computed: {
        linkPublish() {
            const domain = this.dataForm?.custom_domain?.domain || process.env.VUE_APP_DOMAIN_FORM;
            return `https://${domain}/form/${this.dataForm?.url_public}`;
        }
    },
    methods: {
        formatDateForm(date, type) {
            if (date.length > 1) {
                return formatDateCommon(date, type);
            }
        },
        handleMapOptionValue(status, list) {
            return handleStatus(status, list);
        },

        handleJoinParameter(params) {
            if (!params || params.length <= 0) return '';
            return params
                .map((item) => {
                    if (![STATUS_FORM_LIST.PUBLISHING].includes(this.dataForm.status) || this.dataForm.is_first_create) {
                        return `${item?.note ? `${item.note}</br>` : ''}<span>${this.linkPublish}?${item.params}</span>`;
                    } else {
                        return `${item?.note ? `${item.note}</br>` : ''}<a href="${this.linkPublish}?${item.params}" target="_blank">${this.linkPublish}?${item.params}</a>`;
                    }
                })
                .join('</br></br>');
        }
    },
    mounted() {}
};
</script>

<style lang="scss" scoped></style>
